<template>
  <div class="appmain">
    <div class="shadow-bottom">
      <MyBanner />
    </div>

    <div class="content">
      <MyMenus :heightt="menuContenHeight" />
    </div>
    <!-- <div class="foot">
      <div>Copyright@知仁（武汉）科技有限公司 鄂ICP备2025098405号-1</div>
    </div> -->

    <!-- <el-drawer v-model="navDrawerVisible" direction="btt" size="30%" title="菜单导航" class="custom-drawer">
      <div>湘雅医院临床病理数字化教学平台</div>
      <div>华厚科技融媒体</div>
      <div>同步镜像</div>
      <div>取材指导</div>
      <div>远程会诊</div>
    </el-drawer> -->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import MyBanner from "./components/MyBanner.vue";
import MyMenus from "./components/MyMenus.vue";

const menuContenHeight = ref(String);

const setMenuContenHeight = () => {
  console.log("当前高：" + window.innerHeight);
  menuContenHeight.value = `${window.innerHeight - 250}px`;
};

const handleIcpClick = () => {
  window.open("https://beian.miit.gov.cn/", "_blank");
};

onMounted(() => {
  setMenuContenHeight();
});
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}
.appmain {
  /* background-color: #f7f7f7; */
  max-width: 860px;
  margin: 0 auto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid #fff;
}
.shadow-bottom {
  background-color: #ffffff;
  padding: 10px 10px 0;
}

.shadow-bottom :deep(.swiper) {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.shadow-bottom :deep(.swiper-slide img) {
  border: none;
}
/* .content {
  margin: 15px 0;
} */
.notice {
  background-color: #fff9d7;
  margin-top: 15px;
  padding: 5px;
  color: red;
  .noticename {
    font-weight: 600;
    color: red;
  }
  /* .noticetitlee {
    color: #444;
  } */
}

.notincei {
  color: rgb(62, 35, 158);
  font-family: 微软雅黑;
}
.foot {
  width: 100%;
  font-size: 11px;
  text-align: center;
  background-color: #444;
  color: #d3d3d3;
  padding: 5px 0;
}

/* 使用样式穿透修改抽屉样式 */
/* ::v-deep .el-drawer__header {
  margin: 0px !important;
  padding: 1% 0 0 1% !important;
}

::v-deep .el-drawer__body {
  color: #666;
  margin: 0px !important;
  padding: 0px !important;
} */
</style>
